import { Paperclip, FileText, Image as ImageIcon, Volume2, File } from "lucide-react";
import { openStorageFile } from "@/lib/openStorageFile";
import { toast } from "sonner";

const attIcon = { image: ImageIcon, audio: Volume2, pdf: FileText, other: File };

const fmtTime = (d) => {
  try { return new Date(d).toLocaleString("fr-FR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }); }
  catch { return ""; }
};

// me: "coach" | "learner" — determines which side bubbles align to.
export default function MessageThread({ messages, me }) {
  const openAtt = async (m) => {
    if (!m.attachment_path) return;
    try { await openStorageFile(m.attachment_path, m.attachment_name); }
    catch (e) { toast.error(e.message || "Impossible d'ouvrir le fichier"); }
  };

  if (!messages?.length) {
    return <div className="flex-1 flex items-center justify-center text-[#5C6561] text-sm p-6" data-testid="thread-empty">Aucun message pour le moment.</div>;
  }

  return (
    <div className="flex-1 overflow-y-auto p-4 space-y-3" data-testid="message-thread">
      {messages.map((m) => {
        const mine = m.sender === me;
        const Icon = attIcon[m.attachment_kind] || Paperclip;
        return (
          <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`} data-testid={`message-${m.id}`}>
            <div className={`max-w-[80%] rounded-2xl px-4 py-2.5 text-sm ${mine ? "bg-[#D95D39] text-white rounded-br-md" : "bg-white border border-[#E6E1DA] text-[#1F2421] rounded-bl-md"}`}>
              {m.text && <div className="whitespace-pre-wrap break-words">{m.text}</div>}
              {m.attachment_path && (
                <button
                  onClick={() => openAtt(m)}
                  className={`mt-2 inline-flex items-center gap-1.5 text-xs font-medium rounded-lg px-2 py-1 ${mine ? "bg-white/20 text-white" : "bg-[#FDF0EC] text-[#D95D39]"}`}
                  data-testid={`message-attachment-${m.id}`}
                >
                  <Icon className="w-3.5 h-3.5" /> {m.attachment_name || "Pièce jointe"}
                </button>
              )}
              <div className={`text-[10px] mt-1 ${mine ? "text-white/70" : "text-[#5C6561]"}`}>{fmtTime(m.created_at)}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
